import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TableDate, TableAlign } from '../../../../../../global';
import { NgIf } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { DateTransformPipe } from '../../../../../pipes/date-transform.pipe';

@Component({
    selector: 'slm-table-date',
    template: `
    <h5
      *ngIf="data; else invalid"
      [matTooltip]="tooltip | translate"
      [class]="'w-100 m-0 block txt-' + (align || 'center') + '-i'"
    >
      {{ data.date | dateTransform: format || 'short'
      }}{{
        data.until
          ? ' - ' + (data.until | dateTransform: format || 'short')
          : ''
      }}
    </h5>
    <ng-template #invalid
      ><span class="w-100 block txt-center-i">--</span></ng-template
    >
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, MatTooltip, TranslatePipe, DateTransformPipe]
})
export class TableDateComponent {
  @Input() data: TableDate = null;
  @Input() format: string = null;
  @Input() tooltip: string = null;
  @Input() align: TableAlign = TableAlign.CENTER;
}
